import React from 'react';
import { Box, Typography } from '@mui/material';
import { BRAND, BRAND_COLORS } from '../../constants/branding';
import BrainMark from './BrainMark';

type EapLogoVariant = 'full' | 'stacked' | 'mark';

interface EapLogoProps {
  variant?: EapLogoVariant;
  inverted?: boolean;
  markSize?: number;
}

const EapLogo: React.FC<EapLogoProps> = ({
  variant = 'stacked',
  inverted = false,
  markSize,
}) => {
  const wordColor = inverted ? BRAND_COLORS.lightLavender : BRAND_COLORS.darkPurple;
  const subColor = inverted ? BRAND_COLORS.white : BRAND_COLORS.mediumPurple;

  if (variant === 'mark') {
    return <BrainMark size={markSize ?? 40} />;
  }

  const wordSize = variant === 'full' ? { xs: '3.25rem', md: '4.25rem' } : '2rem';
  const subSize = variant === 'full' ? '0.85rem' : '0.62rem';

  return (
    <Box sx={{ textAlign: 'center', lineHeight: 1 }}>
      {(variant === 'full' || variant === 'stacked') && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: variant === 'full' ? 1.5 : 1 }}>
          <BrainMark size={markSize ?? (variant === 'full' ? 88 : 52)} />
        </Box>
      )}
      <Typography
        component="span"
        sx={{
          display: 'block',
          fontWeight: 800,
          fontSize: wordSize,
          letterSpacing: '-0.06em',
          color: wordColor,
          lineHeight: 0.85,
          textTransform: 'lowercase',
        }}
      >
        {BRAND.shortName}
      </Typography>
      <Typography
        component="span"
        sx={{
          display: 'block',
          fontWeight: 500,
          fontSize: subSize,
          letterSpacing: '0.38em',
          color: subColor,
          textTransform: 'uppercase',
          mt: 1,
          pl: '0.38em',
        }}
      >
        CONSULTING
      </Typography>
    </Box>
  );
};

export default EapLogo;
